<div class="complex-list-sort">
  <ftr-sort-direction
    align="start"
    [label]="sortBy ? '' : 'Sort by:'"
    (onSelectionChange)="onSortDirectionChange($event)"
    [sortByTemplate]="sortByTemplate"
    [currentValue]="sortDirection"
    [sortDirectionText]="sortDirectionText"
  ></ftr-sort-direction>

  <ng-template #sortByTemplate>
    @if (sortBy) {
      <ftr-composable-dropdown>
        <ftr-composable-dropdown-header>
          <!-- This label is here on purpose so its width can be included in the width of the dropdown -->
          <span class="complex-list-sort__sortby__label">Sort by: </span>
          <button
            class="complex-list-sort__sortby__header"
            [ngClass]="'complex-list-sort__sortby__header--' + sortByDropdownHeaderSize"
          >
            {{ getSortByLabel(sortBy) }}
          </button>
        </ftr-composable-dropdown-header>
        <ftr-composable-dropdown-body>
          @for (option of config.options; track option) {
            <div
              class="complex-list-sort__sortby__option"
              tabindex="0"
              (click)="onSortByChange(option.value)"
              (keydown.enter)="onSortByChange(option.value)"
            >
              {{ option.key }}
            </div>
          }
        </ftr-composable-dropdown-body>
      </ftr-composable-dropdown>
    }
  </ng-template>
</div>
